var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 34269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 3L5 6",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 12L5 9",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 34268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.16881 8.71231C2.85223 9.39573 3.96027 9.39573 4.64369 8.71231C5.3271 8.02889 5.3271 6.92085 4.64369 6.23744C3.96027 5.55402 2.85223 5.55402 2.16881 6.23744C1.4854 6.92085 1.4854 8.02889 2.16881 8.71231Z",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 34267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.76256 3.71231C9.44598 4.39573 10.554 4.39573 11.2374 3.71231C11.9209 3.02889 11.9209 1.92085 11.2374 1.23744C10.554 0.554019 9.44598 0.554019 8.76256 1.23744C8.07915 1.92085 8.07915 3.02889 8.76256 3.71231Z",
    fill: "white",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.76256 14.4369C9.44598 15.1203 10.554 15.1203 11.2374 14.4369C11.9209 13.7535 11.9209 12.6455 11.2374 11.962C10.554 11.2786 9.44598 11.2786 8.76256 11.962C8.07915 12.6455 8.07915 13.7535 8.76256 14.4369Z",
    fill: "white",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.5011be6ca2a891c114ad4b25a1683774.svg";
export { ForwardRef as ReactComponent };